import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import cn from 'classnames';
import Loader from '../../../components/utils/Loader';
import { isEmpty } from 'lodash';
import { ItemRow } from './ItemRow';
import { TableHeader } from './TableHeader';
import { useDispatch } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { styles } from '../styles';
import { fetchRawsList } from '../../../action/raw';

export function RawsList() {
    const dispatch = useDispatch();
    const loaderList = useSelector(fromStore.loaderRawSelector);
    const raws = useSelector(fromStore.selectedCategoryRaws);
    const _sort = useSelector(fromStore.sortingRawSelector);

    useEffect(() => ReactTooltip.rebuild(), [raws, loaderList]);

    useEffect(() => {
        isEmpty(raws) && dispatch(fetchRawsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={
                            cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded', {
                                'kt-datatable--error': isEmpty(raws)
                            })
                        }>
                        {loaderList && <div style={styles.tableLoading}><Loader text='Загружаю товары'/></div>}
                        <table className="kt-datatable__table" style={ window.innerWidth > 730 ? { minHeight: '700px' } : {}}>
                           {window.innerWidth > 730 && <TableHeader/>}
                                <tbody className="kt-datatable__body">
                                    {
                                        loaderList
                                            ? null
                                            : isEmpty(raws)
                                                ? <tr><td colSpan={8}><span className="kt-datatable--error">Сырье не найдено</span></td></tr>
                                                : raws.sort((a, b) => {
                                                    const { type, field } = _sort;
                                                    const aField = a[field || 'id'];
                                                    const bField = b[field || 'id'];
                                                    if (type === 'DESC') {
                                                        if (typeof aField === 'string') {
                                                            if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                                            if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                                            return 0;
                                                        }
                                                        return bField - aField;  
                                                    } else {
                                                        if (typeof aField === 'string') {
                                                            if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                                            if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                                            return 0;
                                                        }
                                                        return aField - bField;                                                        
                                                    }
                                                }).map((item) => <ItemRow key={item.id} item={item}/>)
                                    }
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
}